import React from 'react'
import '../TemplateMessage/GenericTemplate/TemplateMessage.css'
import { generatePostBackObject } from '../../../actions/static'

const setWidgetColor = color => ({
  color: color,
  borderColor: color,
})

class QuickReply extends React.Component {
  render() {
    const { reply, color } = this.props
    return (
      <div
        className="quick_reply"
        style={setWidgetColor(color)}
        onClick={() => this.props.postMessage(generatePostBackObject(reply))}>
        <span>{reply.title}</span>
      </div>
    )
  }
}

export default QuickReply
